'use client'

import {Text} from '@/components/ui/Typography'
import {useTranslations} from '@/i18n/hooks/useTranslations'
import {useEffect} from 'react'

type Props = {
  error: Error
  reset(): void
}

export default function Error({error, reset}: Props) {
  const t = useTranslations()

  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div>
      <Text className="mt-4">{t('error.description')}</Text>
      <button className="text-white underline underline-offset-2" onClick={reset} type="button">
        {t('error.retry')}
      </button>
    </div>
  )
}
